import { contact } from "../actions/contact";
import { createAsyncActionReducer } from "./api";
export default createAsyncActionReducer([contact]);
